"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Indicators_1 = require("../../../Indicators");
var EntryStatusCell_styles_1 = require("./EntryStatusCell.styles");
exports.default = (function (_a) {
    var value = _a.value;
    return (React.createElement(EntryStatusCell_styles_1.Container, null,
        React.createElement(Indicators_1.EntryStatusMarker, { Status: value })));
});
